// import 'bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navb from './Nav/Navb';
import About from './Pages/About/About';
import ContactForm from './Pages/Form/ContactForm';
import Footer from'../src/Pages/Footer/Footer'
import Header from './Pages/Header/Header';
import Projects from './Pages/Projects/Projects';
import { Routes, Route, Link } from "react-router-dom";
import WebDevelopment from './Pages/Projects/WebDevelopment/WebDevelopment';
import MachineLearning from './Pages/Projects/MachineLearning/MachineLearning';

function App() {
  return (
    <div>
      <Navb></Navb>
      <Routes>
        <Route path='/' element={<Header />} />
        <Route path='/home' element={<Header />} />
        <Route path='/projects' element={<Projects/>} />
        <Route path='/aboutme' element={<About/>} />
        {/* <Route path='/' element={<Header/>}>
        <Route path='/' element={<Header/>}> */}
        <Route path="/web-development" element={<WebDevelopment></WebDevelopment>}></Route>
        <Route path="/machine-learning" element={<MachineLearning></MachineLearning>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
